var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18202F",
    fillRule: "nonzero",
    d: "M16.087 17.2h-1.522v-1.8c0-2.277-1.262-4.332-3.26-5.4 1.998-1.068 3.26-3.123 3.26-5.4V2.8h1.522A.908.908 0 0 0 17 1.9c0-.496-.41-.9-.913-.9H3.913A.908.908 0 0 0 3 1.9c0 .496.41.9.913.9h1.522v1.8c0 2.277 1.262 4.332 3.26 5.4-1.998 1.068-3.26 3.123-3.26 5.4v1.8H3.913a.908.908 0 0 0-.913.9c0 .496.41.9.913.9h12.174a.908.908 0 0 0 .913-.9c0-.496-.41-.9-.913-.9zM3.913 2.2a.303.303 0 0 1-.304-.3c0-.166.136-.3.304-.3h12.174c.168 0 .304.134.304.3 0 .166-.136.3-.304.3H3.913zm2.13 2.4V2.8h7.914v1.8c0 2.228-1.337 4.223-3.41 5.1H9.453c-2.073-.877-3.41-2.872-3.41-5.1zm0 10.8c0-2.228 1.337-4.223 3.41-5.1h1.094c2.073.877 3.41 2.872 3.41 5.1v1.8c0-.166-.137-.3-.305-.3a.302.302 0 0 0-.304.3h-.609c0-.166-.136-.3-.304-.3a.302.302 0 0 0-.305.3h-.608c0-.166-.137-.3-.305-.3a.302.302 0 0 0-.304.3h-.609c0-.166-.136-.3-.304-.3a.302.302 0 0 0-.304.3h-.609c0-.166-.136-.3-.304-.3a.302.302 0 0 0-.305.3H7.87c0-.166-.137-.3-.305-.3a.302.302 0 0 0-.304.3h-.609c0-.166-.136-.3-.304-.3a.302.302 0 0 0-.305.3v-1.8zm10.044 3H3.913a.303.303 0 0 1-.304-.3c0-.166.136-.3.304-.3H16.087c.168 0 .304.134.304.3 0 .166-.136.3-.304.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.957,
    cy: 16.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.174,
    cy: 16.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.391,
    cy: 16.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.609,
    cy: 16.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.826,
    cy: 16.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.043,
    cy: 16.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.565,
    cy: 16,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.783,
    cy: 16,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 10.9,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.174,
    cy: 7.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.391,
    cy: 7.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.609,
    cy: 7.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.826,
    cy: 7.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.217,
    cy: 7,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.826,
    cy: 6.4,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.783,
    cy: 7,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 7,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.174,
    cy: 6.4,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.783,
    cy: 8.2,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.391,
    cy: 8.8,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.609,
    cy: 8.8,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 8.2,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.217,
    cy: 8.2,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 11.8,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 12.7,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 13.6,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 14.5,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 15.4,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.217,
    cy: 16,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.435,
    cy: 16,
    fill: "#18202F",
    fillRule: "nonzero",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHourglass);
export default __webpack_public_path__ + "static/media/ic-hourglass.85c9dd0612d3abacfded5be273b52de9.svg";
export { ForwardRef as ReactComponent };